<template>
  <article class="cast_article">
    <figure class="cast_article--image">
      <img :src="cast.cast_image" :alt="cast.cast_name">
    </figure>
    <section>
      <h3 class="cast_article--title">{{cast.cast_name}}</h3>
      <p class="cast_article--subtitle">{{cast.cast_role}}</p>

      <button type="button" name="more" class="button_more" :title="cast.cast_name" @click="showInfo()">more</button>
    </section>
  </article>
</template>

<script>
export default {
  name: 'cast-item',
  props: {
    cast: Object
  },
  data () {
    return {
    }
  },

  methods: {
    showInfo () {
      let currentItem = {
        title: this.cast.cast_name,
        role: this.cast.cast_role,
        intro: this.cast.cast_intro,
        isCast: true
      }
      this.$emit('showModal', currentItem)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CastItem.vue